import { apiClient, apiFetchWithMeta } from '@/lib/api-client';
import type { Customer } from '@/types/api';

export interface CustomerListFilters {
  status?: string | undefined;
  search?: string | undefined;
  planId?: string | undefined;
  interval?: string | undefined;
  cursor?: string | undefined;
}

/** Cache key for the customer list, shared so every mutation can invalidate the same entry. */
export const ADMIN_CUSTOMERS_KEY = ['admin-customers'] as const;

export const adminCustomersApi = {
  list: (filters: CustomerListFilters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.set('status', filters.status);
    if (filters.search) params.set('search', filters.search);
    if (filters.planId) params.set('plan_id', filters.planId);
    if (filters.interval) params.set('interval', filters.interval);
    if (filters.cursor) params.set('cursor', filters.cursor);

    const query = params.toString();
    return apiFetchWithMeta<Customer[]>(`/admin/customers${query ? `?${query}` : ''}`);
  },

  /**
   * Creates the account and its login together. The password is shown to the administrator
   * once, to hand over — the platform never displays it again.
   */
  create: (input: {
    name: string;
    email: string;
    password: string;
    company?: string;
    notes?: string;
  }) => apiClient.post<Customer>('/admin/customers', input),

  suspend: (id: string, reason: string) =>
    apiClient.post<Customer>(`/admin/customers/${id}/suspend`, { reason }),

  restore: (id: string) => apiClient.post<Customer>(`/admin/customers/${id}/restore`, {}),

  /** As close to deletion as the platform offers: everything is retained. */
  archive: (id: string, reason: string) =>
    apiClient.post<Customer>(`/admin/customers/${id}/archive`, { reason }),
};
